export interface InventoryItem {
  nomenclature: string;
  category: string;
  warehouse: string;
  quantity: number;
  reserved: number;
  unit: string;
  minStock: number;
}

export const inventory: InventoryItem[] = [
  {
    nomenclature: "Ткань х/б арт. ТХ-100",
    category: "Ткани хлопчатобумажные",
    warehouse: "Склад №1 (Основной)",
    quantity: 8500,
    reserved: 2500,
    unit: "м",
    minStock: 1000,
  },
  {
    nomenclature: "Ткань лён арт. ЛН-200",
    category: "Ткани льняные",
    warehouse: "Склад №1 (Основной)",
    quantity: 3200,
    reserved: 550,
    unit: "м",
    minStock: 500,
  },
  {
    nomenclature: "Ткань джинсовая арт. ДЖ-800",
    category: "Ткани хлопчатобумажные",
    warehouse: "Склад №1 (Основной)",
    quantity: 4500,
    reserved: 800,
    unit: "м",
    minStock: 600,
  },
  {
    nomenclature: "Ткань костюмная арт. КС-400",
    category: "Ткани костюмные",
    warehouse: "Склад №1 (Основной)",
    quantity: 2100,
    reserved: 430,
    unit: "м",
    minStock: 300,
  },
  {
    nomenclature: "Ткань шёлк арт. ШЛ-500",
    category: "Ткани шёлковые",
    warehouse: "Склад №2 (Ткани)",
    quantity: 850,
    reserved: 160,
    unit: "м",
    minStock: 100,
  },
  {
    nomenclature: "Ткань шерсть арт. ШР-300",
    category: "Ткани шерстяные",
    warehouse: "Склад №2 (Ткани)",
    quantity: 1200,
    reserved: 450,
    unit: "м",
    minStock: 200,
  },
  {
    nomenclature: "Ткань плащёвая арт. ПЛ-150",
    category: "Ткани синтетические",
    warehouse: "Склад №2 (Ткани)",
    quantity: 2800,
    reserved: 350,
    unit: "м",
    minStock: 300,
  },
  {
    nomenclature: "Ткань подкладочная арт. ПД-50",
    category: "Ткани подкладочные",
    warehouse: "Склад №2 (Ткани)",
    quantity: 5200,
    reserved: 620,
    unit: "м",
    minStock: 500,
  },
  {
    nomenclature: "Нитки полиэстер №40",
    category: "Нитки синтетические",
    warehouse: "Склад №3 (Фурнитура)",
    quantity: 15000,
    reserved: 730,
    unit: "шт",
    minStock: 500,
  },
  {
    nomenclature: "Нитки х/б №30",
    category: "Нитки хлопчатобумажные",
    warehouse: "Склад №3 (Фурнитура)",
    quantity: 4800,
    reserved: 220,
    unit: "шт",
    minStock: 300,
  },
  {
    nomenclature: "Нитки армированные №70",
    category: "Нитки армированные",
    warehouse: "Склад №3 (Фурнитура)",
    quantity: 8200,
    reserved: 340,
    unit: "шт",
    minStock: 400,
  },
  {
    nomenclature: "Молнии YKK 60см",
    category: "Фурнитура",
    warehouse: "Склад №3 (Фурнитура)",
    quantity: 2100,
    reserved: 130,
    unit: "шт",
    minStock: 200,
  },
  {
    nomenclature: "Пуговицы пластик d18",
    category: "Фурнитура",
    warehouse: "Склад №3 (Фурнитура)",
    quantity: 8500,
    reserved: 212,
    unit: "шт",
    minStock: 500,
  },
  {
    nomenclature: "Пуговицы дерево d22",
    category: "Фурнитура",
    warehouse: "Склад №3 (Фурнитура)",
    quantity: 3200,
    reserved: 82,
    unit: "шт",
    minStock: 200,
  },
  {
    nomenclature: "Фурнитура металл набор",
    category: "Фурнитура",
    warehouse: "Склад №3 (Фурнитура)",
    quantity: 420,
    reserved: 80,
    unit: "наб",
    minStock: 50,
  },
];